<template functional>
  <svg
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
  >
    <g transform="translate(-0.7 -0.5)">
      <path
        d="M9.025,12.664l3.15,2a.53.53,0,0,0,.787-.593l-.912-3.588a.543.543,0,0,1,.181-.55l2.825-2.356a.542.542,0,0,0-.3-.956l-3.687-.238a.519.519,0,0,1-.456-.337L9.237,2.583a.519.519,0,0,0-.975,0L6.888,6.046a.519.519,0,0,1-.456.337l-3.688.238a.542.542,0,0,0-.3.956L5.269,9.933a.544.544,0,0,1,.181.55l-.844,3.325a.633.633,0,0,0,.937.713l2.931-1.857a.512.512,0,0,1,.55,0h0Z"
        fill="none"
        stroke="#74788d"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        :style="{ fill: 'none !important' }"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconStar',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>